export const T = {
  en_GB: {
    // The locale this table is for — the member lines format "{rep} ({role})" with it.
    locale: "en_GB",
    memberCountConfirmed: (passed: number, total: number) => `${passed} of ${total} confirmed`,
    expandMembers: "Show members",
    collapseMembers: "Hide members",
    // QL-654 — a client with 2+ representatives: every representative answers for themselves.
    expandRepresentatives: "Show representatives",
    collapseRepresentatives: "Hide representatives",
  },
  nb_NO: {
    locale: "nb_NO",
    memberCountConfirmed: (passed: number, total: number) => `${passed} av ${total} bekreftet`,
    expandMembers: "Vis medlemmer",
    collapseMembers: "Skjul medlemmer",
    expandRepresentatives: "Vis representanter",
    collapseRepresentatives: "Skjul representanter",
  },
} as const;
